import { useState } from 'react'
import { getDateRange, type TimeTab } from '../utils/dates'

export type DateTab = TimeTab

export interface UseDateRangeReturn {
  tab: DateTab
  setTab: (tab: DateTab) => void
  customFrom: string
  setCustomFrom: (val: string) => void
  customTo: string
  setCustomTo: (val: string) => void
  from: string
  to: string
}

export function useDateRange(initialTab: DateTab = 'month'): UseDateRangeReturn {
  const [tab, setTab] = useState<DateTab>(initialTab)
  const [customFrom, setCustomFrom] = useState('')
  const [customTo, setCustomTo] = useState('')

  const { from, to } = getDateRange(tab, customFrom, customTo)

  return { tab, setTab, customFrom, setCustomFrom, customTo, setCustomTo, from, to }
}

export const DATE_TABS: { value: DateTab; label: string }[] = [
  { value: 'today', label: 'Today' },
  { value: 'week', label: 'This Week' },
  { value: 'month', label: 'This Month' },
  { value: 'quarter', label: 'This Quarter' },
  { value: 'year', label: 'This Year' },
  { value: 'custom', label: 'Custom' },
]
